import { atom } from 'jotai';

import {
  type ClassPlanningFilters,
  INITIAL_CLASS_PLANNING_FILTERS,
} from '../../types/classPlanningFilters';

/**
 * Átomo com o estado **aplicado** dos filtros da listagem de planejamento de aulas.
 *
 * O `ClassPlanningFilterBar` mantém o estado pendente localmente e só grava aqui
 * ao acionar "Filtrar". Deve ser consumido apenas via `useClassPlanningFilters`
 * (CLAUDE.md proíbe `useAtom` direto em componentes).
 */
export const classPlanningFiltersAtom = atom<ClassPlanningFilters>(INITIAL_CLASS_PLANNING_FILTERS);
